import { render, staticRenderFns } from "./blockChainTransactionView.vue?vue&type=template&id=4ef34c00&scoped=true&"
import script from "./blockChainTransactionView.vue?vue&type=script&lang=js&"
export * from "./blockChainTransactionView.vue?vue&type=script&lang=js&"
import style0 from "./blockChainTransactionView.vue?vue&type=style&index=0&id=4ef34c00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef34c00",
  null
  
)

export default component.exports